import { render } from "./GlobalChatBubble.vue?vue&type=template&id=df4e8a46&scoped=true"
import script from "./GlobalChatBubble.vue?vue&type=script&lang=js"
export * from "./GlobalChatBubble.vue?vue&type=script&lang=js"

import "./GlobalChatBubble.vue?vue&type=style&index=0&id=df4e8a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4e8a46"]])

export default __exports__